var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'artist-detail', params: {slug: _vm.artist.person_slug} }}},[_c('v-img',{staticClass:"column rounded",attrs:{"src":_vm.mediaUrl + '/' + _vm.artist.photo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }